<template>
  <div class="content">
    <div id="page">
      <div class="page">
        <a href="" @click="closePage">Finaliser la transaction</a>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payment-redirect',
  methods: {
    closePage(event) {
      event.preventDefault();
      window.close();
    },
  },
};

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/payment-redirect.vue